import { DateTimeString, getDateTimeString } from "../../dateTypes.js";
import { CellExecutionState } from "../../enums.js";
import { AppSessionCellId } from "../../idTypeBrands.js";
import { typedObjectEntries } from "../../utils/typedObjects.js";
import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";

export const UPDATE_APP_SESSION_CELL = createAppSessionEventDefinition({
  type: "UPDATE_APP_SESSION_CELL",
  logSafe: {
    appSessionCellId: true,
    state: true,
    lastExecutionEndTime: true,
    lastExecutionStartTime: true,
  },
  create: ({
    lastExecutionEndTime,
    lastExecutionStartTime,
    ...rest
  }: {
    appSessionCellId: AppSessionCellId;
    state?: CellExecutionState;
    lastExecutionEndTime?: Date | DateTimeString | null;
    lastExecutionStartTime?: Date | DateTimeString | null;
  }) => ({
    lastExecutionEndTime:
      lastExecutionEndTime instanceof Date
        ? getDateTimeString(lastExecutionEndTime)
        : lastExecutionEndTime,
    lastExecutionStartTime:
      lastExecutionStartTime instanceof Date
        ? getDateTimeString(lastExecutionStartTime)
        : lastExecutionStartTime,
    ...rest,
  }),
  apply: (previousState, { appSessionCellId, ...payload }) => {
    const appSessionCell = previousState.appSessionCells[appSessionCellId];
    if (appSessionCell == null) {
      throw Error(`App session cell not found: ${appSessionCellId}`);
    }

    for (const entry of typedObjectEntries(payload)) {
      if (entry != null) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- we know that this key must match
        appSessionCell[entry[0]] = entry[1] as any;
      }
    }
  },
});
